// Registrar o plugin ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Importar a logo do preloader
const logoUrl = '/logo-portfolio.svg';
const defaultLanguage = 'en';
let currentLanguage = localStorage.getItem('language') || defaultLanguage;
let heroTypingRunId = 0;

const translations = {
  'pt-BR': {
    'nav.home': 'Home',
    'nav.about': 'Sobre',
    'nav.projects': 'Projetos',
    'nav.experience': 'Experiência',
    'nav.skills': 'Skills',
    'hero.tag': '<meu_portfolio />',
    'hero.title': 'Olá, meu nome<br>é <span class="highlight">Yuri</span>',
    'hero.role1': 'AI Engineer',
    'hero.role2': 'Python | GenAI | LLMs | AI Agents | RAG Systems | LangChain',
    'hero.description': 'Sou AI Engineer focado em construir sistemas com LLMs, AI Agents e RAG Systems, transformando desafios reais de negócio em soluções escaláveis e de baixo custo.',
    'about.title': 'Sobre Mim',
    'about.p1': 'Eu projeto e construo sistemas de IA prontos para produção com escalabilidade, performance e alta confiabilidade, sempre focado em impacto de negócio e entrega de valor para clientes.',
    'about.p2': 'Como AI Engineer com base sólida em Sistemas de Informação, conecto modelos avançados de machine learning com engenharia de software robusta. Meu foco é criar backends de alta performance e aplicações inteligentes com GenAI, orientadas a resultado real.',
    'about.stackTitle': 'Tenho experiência prática em projetar e entregar:',
    'about.skill1': 'AI Agents autônomos com orquestração avançada',
    'about.skill2': 'Arquiteturas RAG (Retrieval-Augmented Generation) com bancos vetoriais',
    'about.skill3': 'Cloud computing (AWS, Redis, Docker, Kubernetes, Render, Supabase, Cloudflare, etc.)',
    'about.skill4': 'Python (Transformers, LangChain, Pandas, Polars, NumPy, Apache Spark, Scikit-learn, Streamlit, Django, FastAPI, Celery)',
    'about.skill5': 'Machine Learning',
    'about.skill6': 'SQL (PostgreSQL, MySQL, SQL Server)',
    'about.skill7': 'NoSQL',
    'about.skill8': 'Data pipelines',
    'about.skill9': 'PyTorch',
    'about.skill10': 'TensorFlow',
    'about.skill11': 'Google Cloud Platform (GCP)',
    'about.skill12': 'AWS',
    'about.skill13': 'Azure',
    'about.skill14': 'Processos ETL/ELT',
    'about.skill15': 'N8N',
    'about.skill16': 'Scrum',
    'about.skill17': 'APIs de LLM (OpenAI, LLaMA, Grok)',
    'about.skill18': 'Desenvolvimento com apoio de LLMs (GitHub Copilot, Claude AI CLI, Windsurf, Cursor, etc.)',
    'projects.title': 'Projetos',
    'projects.tab.powerbi': 'Power BI',
    'projects.tab.github': 'GitHub',
    'projects.tab.systems': 'Sistemas/Sites',
    'projects.buh.desc': 'Dashboard de análise de vendas integrado com API Totvs Moda, proporcionando insights valiosos e auxiliando na tomada de decisões estratégicas.',
    'projects.mcd.desc': 'Dashboard de vendas e estoque integrado com API Linx, permitindo análise detalhada de KPIs e monitoramento eficiente do estoque.',
    'projects.statera.desc': 'Dashboard de chamados e dispositivos com integracao API, oferecendo visao abrangente da operacao de atendimento aos clientes.',
    'projects.portfolio.desc': 'Portfolio pessoal desenvolvido com HTML, CSS e JavaScript, utilizando GSAP para animacoes.',
    'projects.apiSuite.desc': 'Conjunto de APIs desenvolvidas em Python para integracao e automacao de processos.',
    'projects.dataAnalysis.desc': 'Projetos de análise de dados usando Python, Pandas e bibliotecas de visualização.',
    'projects.etl.desc': 'Pipeline de ETL para processamento e transformacao de dados em larga escala.',
    'projects.dashboard.desc': 'Aplicacao web para visualizacao de dashboards interativos com React.',
    'projects.ml.desc': 'Colecao de modelos de Machine Learning para diferentes casos de uso.',
    'projects.gestri.desc': 'Sistema de análise tributária para auxiliar na definição do melhor regime tributário para empresas e pessoas físicas.',
    'projects.gestri.title': 'GesTri - Análise Tributária',
    'projects.arbor.desc': 'Landing page da clínica Arbor Saúde Mental, feita sob medida para um cliente e amigo.',
    'projects.arbor.title': 'Arbor Saúde Mental',
    'projects.gti.desc': 'Landing page do canal de carros no YouTube, apresentando conteudo e informacoes sobre o canal.',
    'projects.gti.title': 'Falando de GTI',
    'projects.roberta.desc': 'Site institucional apresentando os serviços e especialidades da Dra. Roberta Moura.',
    'projects.roberta.title': 'Dra Roberta Moura',
    'projects.nayara.desc': 'Site institucional focado em apresentar os serviços e abordagens da psicóloga Nayara Freitas.',
    'projects.nayara.title': 'Psicóloga Nayara Freitas',
    'projects.f1.desc': 'Plataforma de análise da Fórmula 1 utilizando inteligência artificial para prever resultados das corridas.',
    'projects.f1.title': 'F1 Analytics',
    'common.viewProject': 'Ver Projeto',
    'common.viewGithub': 'Ver no GitHub',
    'experience.title': 'Experiência',
    'experience.vivo.role': 'AI Engineer (Atual)',
    'experience.vivo.desc': 'Como AI Engineer, desenvolvo subsistemas que orquestram pipelines de dados e APIs, integrando relatórios usados por LLMs para responder perguntas críticas de negócio. Atuo com APIs de alta performance em Python (FastAPI e Django), otimizadas para streaming de baixa latência e fluxos complexos de tool chaining.',
    'experience.vp6.role': 'AI Engineer (2022-2025)',
    'experience.vp6.desc': 'Atuei como AI Engineer desenvolvendo sistemas backend para web apps que orquestram pipelines e APIs para suportar AI Agents em processos de orçamento administrativo. Desenvolvi ETL/ELT e APIs em Python (Django, Pandas e Polars), com otimização de performance e custos em nuvem para aplicações baseadas em LLM.',
    'experience.statera.role': 'Analista de Processos/Dados (2020-2022)',
    'experience.statera.desc': 'Desenvolvimento de projetos de análise de dados avançados e melhoria de processos. Primeiro contato com Power BI e início do desenvolvimento de projetos de análise para diversos clientes.',
    'experience.sonda.role': 'Lider de equipe de Service Desk (2011-2014)',
    'experience.sonda.desc': 'Gerenciamento de equipes e processos de suporte tecnico, garantindo excelencia no atendimento e resolucao de problemas.',
    'skills.title': 'Skills',
    'skills.python': 'Python',
    'skills.llmApis': 'LLM APIs (OpenAI, LLaMA, Grok)',
    'skills.rag': 'RAG Systems',
    'skills.agents': 'AI Agents & LangChain',
    'skills.cloud': 'Cloud & MLOps (AWS, Docker, Kubernetes)',
    'skills.nosql': 'NoSQL',
    'skills.pytorch': 'PyTorch',
    'skills.tensorflow': 'TensorFlow',
    'skills.gcp': 'Google Cloud Platform (GCP)',
    'skills.aws': 'AWS',
    'skills.azure': 'Azure',
    'skills.vectorDb': 'Vector Databases',
    'skills.dataPipelines': 'Data Pipelines & ETL/ELT',
    'skills.sql': 'SQL (PostgreSQL, MySQL, SQL Server)',
    'theme.toggle': 'Alternar tema',
    'footer.backToTop': 'Voltar ao topo',
    'github.loading': 'Carregando repositórios...',
    'github.noRepos': 'Nenhum repositório encontrado',
    'github.noDescription': 'Sem descrição disponível.',
    'github.fetchErrorTitle': 'Erro ao carregar repositórios',
    'github.fetchErrorDescription': 'Não foi possível carregar os repositórios do GitHub.'
  },
  en: {
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.projects': 'Projects',
    'nav.experience': 'Experience',
    'nav.skills': 'Skills',
    'hero.tag': '<my_portfolio />',
    'hero.title': 'Hello, my name<br>is <span class="highlight">Yuri</span>',
    'hero.role1': 'AI Engineer',
    'hero.role2': 'Python | GenAI | LLMs | AI Agents | RAG Systems | LangChain',
    'hero.description': 'AI Engineer building production-grade GenAI systems with LLMs, AI Agents, and RAG. I turn complex business workflows into scalable, low-latency, cost-efficient products.',
    'about.title': 'About Me',
    'about.p1': 'I design and build production-grade AI systems with scalability, performance, and high reliability, always focused on business impact and delivering value to customers.',
    'about.p2': 'As an AI Engineer with a strong background in Information Systems, I specialize in connecting advanced machine learning models with robust software engineering. My work focuses on building high-performance backend systems and intelligent applications powered by Generative AI, with a strong emphasis on delivering real business value.',
    'about.stackTitle': 'I have hands-on experience designing and deploying:',
    'about.skill1': 'Autonomous AI agents with advanced orchestration',
    'about.skill2': 'RAG (Retrieval-Augmented Generation) architectures with vector databases',
    'about.skill3': 'Cloud computing (AWS, Redis, Docker, Kubernetes, Render, Supabase, Cloudflare, etc.)',
    'about.skill4': 'Python (Transformers, LangChain, Pandas, Polars, NumPy, Apache Spark, Scikit-learn, Streamlit, Django, FastAPI, Celery)',
    'about.skill5': 'Machine Learning',
    'about.skill6': 'SQL (PostgreSQL, MySQL, SQL Server)',
    'about.skill7': 'NoSQL',
    'about.skill8': 'Data pipelines',
    'about.skill9': 'PyTorch',
    'about.skill10': 'TensorFlow',
    'about.skill11': 'Google Cloud Platform (GCP)',
    'about.skill12': 'AWS',
    'about.skill13': 'Azure',
    'about.skill14': 'ETL/ELT processes',
    'about.skill15': 'N8N',
    'about.skill16': 'Scrum',
    'about.skill17': 'LLM APIs (OpenAI, LLaMA, Grok)',
    'about.skill18': 'LLM-powered development (GitHub Copilot, Claude AI CLI, Windsurf, Cursor, etc.)',
    'projects.title': 'Projects',
    'projects.tab.powerbi': 'Power BI',
    'projects.tab.github': 'GitHub',
    'projects.tab.systems': 'Systems/Websites',
    'projects.buh.desc': 'Sales analytics dashboard integrated with Totvs Moda API, providing valuable insights to support strategic decisions.',
    'projects.mcd.desc': 'Sales and inventory dashboard integrated with Linx API, enabling detailed KPI analysis and efficient stock monitoring.',
    'projects.statera.desc': 'Tickets and devices dashboard integrated by API, providing a broad view of customer support operations.',
    'projects.portfolio.desc': 'Personal portfolio built with HTML, CSS, and JavaScript, using GSAP for animations.',
    'projects.apiSuite.desc': 'Set of Python APIs developed for process integration and automation.',
    'projects.dataAnalysis.desc': 'Data analysis projects using Python, Pandas, and visualization libraries.',
    'projects.etl.desc': 'ETL pipeline for large-scale data processing and transformation.',
    'projects.dashboard.desc': 'Web application for interactive dashboard visualization with React.',
    'projects.ml.desc': 'Collection of Machine Learning models for different use cases.',
    'projects.gestri.desc': 'Tax analysis system to help define the best tax regime for companies and individuals.',
    'projects.gestri.title': 'GesTri - Tax Analysis',
    'projects.arbor.desc': 'Landing page for Arbor Mental Health Clinic, custom built for a client and friend.',
    'projects.arbor.title': 'Arbor Mental Health',
    'projects.gti.desc': 'Landing page for a car-focused YouTube channel, presenting channel content and information.',
    'projects.gti.title': 'Falando de GTI',
    'projects.roberta.desc': 'Institutional website presenting Dr. Roberta Moura services and specialties.',
    'projects.roberta.title': 'Dr. Roberta Moura',
    'projects.nayara.desc': 'Institutional website focused on presenting psychologist Nayara Freitas services and approaches.',
    'projects.nayara.title': 'Psychologist Nayara Freitas',
    'projects.f1.desc': 'Formula 1 analytics platform using artificial intelligence to predict race outcomes.',
    'projects.f1.title': 'F1 Analytics',
    'common.viewProject': 'View Project',
    'common.viewGithub': 'View on GitHub',
    'experience.title': 'Experience',
    'experience.vivo.role': 'AI Engineer (Current)',
    'experience.vivo.desc': 'At Vivo Vita, I build AI subsystems that orchestrate data pipelines and APIs, turning enterprise reports into reliable LLM context for critical decisions. I deliver high-performance Python APIs (FastAPI, Django) optimized for low-latency streaming and complex tool-chaining workflows.',
    'experience.vp6.role': 'AI Engineer (2022-2025)',
    'experience.vp6.desc': 'At VP6, I engineered backend platforms for AI-driven budgeting workflows. I built ETL/ELT pipelines and APIs in Python (Django, Pandas, Polars), improving latency and reducing cloud costs for LLM-based applications.',
    'experience.statera.role': 'Process/Data Analyst (2020-2022)',
    'experience.statera.desc': 'Developed advanced data analysis projects and process improvements. First contact with Power BI and early delivery of analytics projects for multiple clients.',
    'experience.sonda.role': 'Service Desk Team Lead (2011-2014)',
    'experience.sonda.desc': 'Managed support teams and technical support processes, ensuring service excellence and effective problem resolution.',
    'skills.title': 'Skills',
    'skills.python': 'Python',
    'skills.llmApis': 'LLM APIs (OpenAI, LLaMA, Grok)',
    'skills.rag': 'RAG Systems',
    'skills.agents': 'AI Agents & LangChain',
    'skills.cloud': 'Cloud & MLOps (AWS, Docker, Kubernetes)',
    'skills.nosql': 'NoSQL',
    'skills.pytorch': 'PyTorch',
    'skills.tensorflow': 'TensorFlow',
    'skills.gcp': 'Google Cloud Platform (GCP)',
    'skills.aws': 'AWS',
    'skills.azure': 'Azure',
    'skills.vectorDb': 'Vector Databases',
    'skills.dataPipelines': 'Data Pipelines & ETL/ELT',
    'skills.sql': 'SQL (PostgreSQL, MySQL, SQL Server)',
    'theme.toggle': 'Toggle theme',
    'footer.backToTop': 'Back to top',
    'github.loading': 'Loading repositories...',
    'github.noRepos': 'No repositories found',
    'github.noDescription': 'No description available.',
    'github.fetchErrorTitle': 'Error loading repositories',
    'github.fetchErrorDescription': 'Could not load GitHub repositories.'
  }
};

function t(key) {
  const selected = translations[currentLanguage] || translations[defaultLanguage];
  return selected[key] || translations[defaultLanguage][key] || key;
}

function updateLanguageButtons() {
  document.querySelectorAll('.lang-btn').forEach(btn => {
    const isActive = btn.dataset.lang === currentLanguage;
    btn.classList.toggle('active', isActive);
  });
}

function applyTranslations(language) {
  currentLanguage = translations[language] ? language : defaultLanguage;
  document.documentElement.lang = currentLanguage === 'en' ? 'en' : 'pt-br';

  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.dataset.i18n;
    const translated = t(key);
    if (!translated) return;

    if (el.dataset.i18nHtml === 'true') {
      el.innerHTML = translated;
    } else {
      el.textContent = translated;
    }
  });

  const themeToggle = document.getElementById('theme-toggle');
  if (themeToggle) {
    themeToggle.title = t('theme.toggle');
  }

  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    backToTop.title = t('footer.backToTop');
  }

  document.querySelectorAll('.github-grid .project-card.github-card .github-card-footer a').forEach(link => {
    if (!link.hasAttribute('data-i18n')) {
      link.textContent = t('common.viewGithub');
    }
  });

  updateLanguageButtons();
  typeHeroDescription();
}

function setupLanguageSwitcher() {
  const savedLanguage = localStorage.getItem('language') || defaultLanguage;
  applyTranslations(savedLanguage);

  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const selectedLanguage = btn.dataset.lang;
      if (!selectedLanguage || selectedLanguage === currentLanguage) return;

      localStorage.setItem('language', selectedLanguage);
      applyTranslations(selectedLanguage);
    });
  });
}

// Configurar a imagem da logo e controlar o preloader assim que o DOM carregar
document.addEventListener('DOMContentLoaded', () => {
  const logoImg = document.getElementById('preloader-logo-img');
  if (logoImg) {
    logoImg.src = logoUrl;
  }
  
  // Iniciar o timer do preloader imediatamente
  const preloader = document.getElementById('preloader');
  setTimeout(() => {
    preloader.classList.add('fade-out');
    
    setTimeout(() => {
      preloader.style.display = 'none';
    }, 600);
  }, 2000);
});

// Garantir que todos os elementos estejam visíveis por padrão
document.addEventListener('DOMContentLoaded', () => {
  ensureHeroSocialInteractive();
  setupLanguageSwitcher();
  // Garante que os elementos skills estejam visíveis mas NÃO força width
  gsap.set('.skill-card', { opacity: 1, clearProps: 'scale,transform' });
  
  // Inicializar as barras de skills para dispositivos móveis
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (isMobile) {
    document.querySelectorAll('.skill-level').forEach(skillLevel => {
      const percentage = skillLevel.getAttribute('data-percentage');
      if (percentage) {
        skillLevel.style.width = percentage;
      }
    });
  }
  
  gsap.set('body', { visibility: 'visible' });
  
  // Inicializa as animações imediatamente após o DOM estar pronto
  setupAnimations();

  // Inicia rotação do tech stack
  initTechStackCarousel();
  
  // Animação de digitação no terminal
  typeTerminalCode();
});

// Rotação automática do Tech Stack em grupos de 3 itens
function initTechStackCarousel() {
  const itemsContainer = document.querySelector('.tech-stack-card .tech-items');
  if (!itemsContainer) return;

  const groups = [
    [
      { name: 'Python', width: '95%' },
      { name: 'LangChain', width: '90%' },
      { name: 'LLM APIs', width: '92%' }
    ],
    [
      { name: 'RAG Systems', width: '92%' },
      { name: 'Cloud', width: '88%' },
      { name: 'ETL/ELT', width: '90%' }
    ]
  ];

  let current = 0;
  const fadeDuration = 350;

  const renderGroup = (group) => {
    itemsContainer.innerHTML = group.map(item => `
      <div class="tech-item">
        <span>${item.name}</span>
        <div class="tech-bar">
          <div class="tech-progress" style="width: ${item.width}"></div>
        </div>
      </div>
    `).join('');
  };

  renderGroup(groups[current]);

  const swapGroup = () => {
    itemsContainer.classList.add('is-fading');
    setTimeout(() => {
      renderGroup(groups[current]);
      requestAnimationFrame(() => {
        itemsContainer.classList.remove('is-fading');
      });
    }, fadeDuration);
  };

  setInterval(() => {
    current = (current + 1) % groups.length;
    swapGroup();
  }, 4500);
}

// Efeito de digitação no texto do hero
function typeHeroDescription() {
  const runId = ++heroTypingRunId;
  const el = document.querySelector('.hero-description');
  if (!el) return;

  const fullText = el.textContent.trim();
  el.textContent = '';

  let index = 0;
  const speed = 35; // ms por caractere

  const typeNext = () => {
    if (runId !== heroTypingRunId) return;

    if (index <= fullText.length) {
      el.textContent = fullText.substring(0, index);
      index += 1;
      setTimeout(typeNext, speed);
    }
  };

  // pequena espera para garantir layout pronto
  setTimeout(typeNext, 200);
}

// Efeito de digitação no código do terminal com loop e cores VSCode
function typeTerminalCode() {
  const terminalContent = document.querySelector('.terminal-content');
  if (!terminalContent) return;

  const codeLines = [
    '<span class="keyword">from</span> openai <span class="keyword">import</span> <span class="class-name">OpenAI</span>',
    '<span class="param">client</span> <span class="operator">=</span> <span class="class-name">OpenAI</span>()',
    '<span class="param">response</span> <span class="operator">=</span> <span class="param">client</span>.<span class="function">responses.create</span>(',
    '  model<span class="operator">=</span>"gpt-4.1-mini",',
    '  input<span class="operator">=</span>"Resuma as vendas da semana"',
    ')',
    '<span class="function">print</span>(<span class="param">response</span>.<span class="param">output_text</span>)'
  ];

  const startAnimation = () => {
    terminalContent.innerHTML = '<pre class="terminal-code"></pre>';
    const codeElement = terminalContent.querySelector('.terminal-code');
    
    let lineIndex = 0;
    let charIndex = 0;
    const typingSpeed = 20; // ms por caractere - reduzido de 40 para 20

    const typeNextChar = () => {
      if (lineIndex < codeLines.length) {
        const currentLine = codeLines[lineIndex];
        
        if (charIndex <= currentLine.length) {
          const displayedLines = codeLines.slice(0, lineIndex).join('\n') + 
            (lineIndex > 0 ? '\n' : '') +
            currentLine.substring(0, charIndex);
          
          codeElement.innerHTML = displayedLines;
          
          charIndex++;
          setTimeout(typeNextChar, typingSpeed);
        } else {
          // Próxima linha
          lineIndex++;
          charIndex = 0;
          setTimeout(typeNextChar, typingSpeed);
        }
      } else {
        // Animação completa, esperar 2s e reiniciar (reduzido de 3s)
        setTimeout(startAnimation, 2000);
      }
    };

    typeNextChar();
  };

  // Iniciar após um pequeno delay - reduzido de 800 para 400
  setTimeout(startAnimation, 400);
}

// Configuração para navegação com scroll suave
const sections = document.querySelectorAll('section');
const navLinks = document.querySelectorAll('nav a');

// Atualiza a navegação durante o scroll
function updateNavigation() {
  const scrollPos = window.scrollY + 200;
  
  sections.forEach(section => {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    
    if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
      const currentId = section.getAttribute('id');
      
      navLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${currentId}`) {
          link.classList.add('active');
        }
      });
    }
  });
}

// Atualiza a navegação quando a página é rolada
window.addEventListener('scroll', updateNavigation);

// Configuração das transições fade entre seções
navLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetSection = document.getElementById(targetId);
    
    // Adiciona transição fade-out a todos os sections
    gsap.to(sections, {
      opacity: 0.3,
      duration: 0.3,
      ease: 'power1.out'
    });
    
    // Adiciona transição fade-in para a seção alvo
    gsap.to(targetSection, {
      opacity: 1,
      duration: 0.5,
      ease: 'power1.in',
      onComplete: () => {
        // Volta a visibilidade dos outros sections após a transição
        gsap.to(sections, {
          opacity: 1,
          duration: 0,
          overwrite: true
        });
      }
    });
    
    // Rola suavemente para a seção
    window.scrollTo({
      top: targetSection.offsetTop,
      behavior: 'smooth'
    });
  });
});

// Funcionalidade das abas com animações
const tabBtns = document.querySelectorAll('.tab-btn');
const tabContents = document.querySelectorAll('.tab-content');

tabBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    const target = btn.dataset.tab;
    
    // Atualiza os botões
    tabBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    
    // Verificar se a aba selecionada é a de repositórios GitHub
    // e carregar os projetos apenas quando esta aba for selecionada
    if (target === 'github') {
      const githubGrid = document.querySelector('.github-grid');
      // Verificar se já carregamos os repositórios antes de fazer a chamada à API
      if (!githubGrid.hasChildNodes() || githubGrid.dataset.loaded !== 'true') {
        // Mostrar indicador de carregamento
        githubGrid.innerHTML = `<div class="loading-indicator"><i class="fas fa-spinner fa-spin"></i> ${t('github.loading')}</div>`;
        // Chamar API do GitHub
        fetchGitHubProjects();
      }
    }
    
    // Animação de saída
    gsap.to('.tab-content.active', {
      opacity: 0,
      y: -20,
      duration: 0.3,
      ease: 'power2.in',
      onComplete: () => {
        // Atualiza o conteúdo
        tabContents.forEach(content => {
          content.classList.remove('active');
          if (content.id === target) {
            content.classList.add('active');
            // Animação de entrada
            gsap.fromTo(content, 
              { opacity: 0, y: 20 },
              { 
                opacity: 1, 
                y: 0, 
                duration: 0.5,
                ease: 'power2.out'
              }
            );
            
            // Anima os cards do conteúdo ativo
            const cards = content.querySelectorAll('.project-card');
            gsap.fromTo(cards, 
              { opacity: 0, y: 30 },
              {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.1,
                ease: 'power2.out'
              }
            );
          }
        });
      }
    });
  });
});

// Função simplificada para carregar o token do GitHub sem depender do dotenv
async function loadGitHubToken() {
  try {
    // Em ambiente de produção, usamos a variável de ambiente da aplicação
    if (typeof process !== 'undefined' && process.env && process.env.GITHUB_TOKEN) {
      return process.env.GITHUB_TOKEN;
    }
    
    // Em ambiente de desenvolvimento, tentamos obter do localStorage
    const token = localStorage.getItem('GITHUB_TOKEN');
    if (token) return token;
    
    // Retornar null se não encontrar
    console.warn('Token do GitHub não encontrado. Configure o token para evitar limites de requisição da API.');
    return null;
  } catch (error) {
    console.error('Erro ao carregar token do GitHub:', error);
    return null;
  }
}

// Função para buscar e exibir projetos do GitHub
async function fetchGitHubProjects() {
  try {
    const githubGrid = document.querySelector('.github-grid');
    // Exibir indicador de carregamento
    githubGrid.innerHTML = `<div class="loading-indicator"><i class="fas fa-spinner fa-spin"></i> ${t('github.loading')}</div>`;
    
    const token = await loadGitHubToken();
    
    // Configuração do cabeçalho com autenticação obrigatória
    const headers = {
      'Accept': 'application/vnd.github.v3+json'
    };
    
    if (token) {
      headers['Authorization'] = `token ${token}`;
      console.log('Usando autenticação para API do GitHub');
    } else {
      console.warn('Token do GitHub não encontrado. As requisições podem ser limitadas pela API.');
    }
    
    // Buscar todos os repositórios do usuário usando a API autenticada
    const response = await fetch('https://api.github.com/users/yurivfernandes1/repos', {
      headers: headers
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Erro na API do GitHub: ${errorData.message}`);
    }
    
    // Verificar se estamos atingindo o limite de taxa da API
    const rateLimitRemaining = response.headers.get('X-RateLimit-Remaining');
    if (rateLimitRemaining && parseInt(rateLimitRemaining) < 10) {
      console.warn(`Aviso: Restam apenas ${rateLimitRemaining} requisições à API do GitHub.`);
    }
    
    let repos = await response.json();
    
    // Verificar se a resposta contém um erro
    if (repos.message) {
      throw new Error(`Erro na API do GitHub: ${repos.message}`);
    }
    
    // Ordenar os repositórios pelo número de estrelas (do maior para o menor)
    repos = repos.sort((a, b) => b.stargazers_count - a.stargazers_count);
    
    // Limitar a 6 repositórios
    repos = repos.slice(0, 6);
    
    githubGrid.innerHTML = '';
    
    // Verificar se temos repositórios para exibir
    if (repos.length === 0) {
      githubGrid.innerHTML = `<div class="project-card github-card"><h3>${t('github.noRepos')}</h3></div>`;
      githubGrid.dataset.loaded = 'true';
      return;
    }
    
    // Mapear linguagens para suas cores correspondentes
    const languageColors = {
      "JavaScript": "#f1e05a",
      "TypeScript": "#3178c6",
      "HTML": "#e34c26",
      "CSS": "#563d7c",
      "Python": "#3572A5",
      "Java": "#b07219",
      "C": "#555555",
      "C++": "#f34b7d",
      "C#": "#178600",
      "Ruby": "#701516",
      "PHP": "#4F5D95",
      "Go": "#00ADD8",
      "Swift": "#ffac45",
      "Kotlin": "#A97BFF",
      "Dart": "#00B4AB",
      "Rust": "#DEA584",
      "Shell": "#89e051",
      "Objective-C": "#438eff",
      "Vue": "#41b883"
    };
    
    // Para cada repositório, buscar detalhes adicionais incluindo as linguagens
    for (const repo of repos) {
      try {
        // Obter detalhes das linguagens do repositório
        const languagesResponse = await fetch(`https://api.github.com/repos/${repo.full_name}/languages`, {
          headers: headers
        });
        
        if (!languagesResponse.ok) {
          throw new Error(`Erro ao obter linguagens: ${languagesResponse.statusText}`);
        }
        
        const languages = await languagesResponse.json();
        
        // Converter linguagens em um array e pegar as 3 principais
        const languagesArray = Object.keys(languages);
        const topLanguages = languagesArray.slice(0, 3);
        
        const card = document.createElement('div');
        card.className = 'project-card github-card';
        
        // HTML com múltiplas linguagens
        let languagesHTML = '';
        if (topLanguages.length > 0) {
          languagesHTML = topLanguages.map(lang => {
            const color = languageColors[lang] || "#858585"; // cor padrão se não encontrar
            return `<span class="github-lang">
              <span class="lang-color" style="background-color: ${color};"></span>
              ${lang}
            </span>`;
          }).join(' ');
        } else {
          languagesHTML = '<span class="github-lang">N/A</span>';
        }
        
        card.innerHTML = `
          <h3>${repo.name}</h3>
          <p>${repo.description || t('github.noDescription')}</p>
          <div class="github-stats">
            <span><i class="fas fa-star"></i> ${repo.stargazers_count}</span>
            <span><i class="fas fa-code-branch"></i> ${repo.forks_count}</span>
            <span><i class="fas fa-eye"></i> ${repo.watchers_count}</span>
          </div>
          <div class="github-card-footer">
            <div class="github-languages">
              ${languagesHTML}
            </div>
            <a href="${repo.html_url}" target="_blank" rel="noopener noreferrer">${t('common.viewGithub')}</a>
          </div>
        `;
        
        githubGrid.appendChild(card);
      } catch (detailError) {
        console.error('Erro ao buscar detalhes do repositório:', detailError);
      }
    }
    
    // Marca que os dados foram carregados com sucesso
    githubGrid.dataset.loaded = 'true';
    
  } catch (error) {
    console.error('Erro ao buscar projetos do GitHub:', error);
    const githubGrid = document.querySelector('.github-grid');
    githubGrid.innerHTML = `<div class="project-card github-card">
      <h3>${t('github.fetchErrorTitle')}</h3>
      <p>${error.message || t('github.fetchErrorDescription')}</p>
    </div>`;
    githubGrid.dataset.loaded = 'false';
  }
}

// Busca os projetos ao carregar a página
fetchGitHubProjects();

// Animações para a seção Skills
function setupSkillsAnimations() {
  const skillCards = document.querySelectorAll('.skill-card');
  const githubStats = document.querySelectorAll('.github-stats-card');
  
  // Garantir que os cards sejam visíveis inicialmente mas NÃO as barras de progresso
  gsap.set(skillCards, { opacity: 1, y: 0 });
  
  // Definir todas as barras de skills para começarem em width 0
  document.querySelectorAll('.skill-level').forEach(skillLevel => {
    // Salvar o valor da porcentagem como atributo
    const percentage = skillLevel.getAttribute('data-percentage');
    if (percentage) {
      skillLevel.setAttribute('data-width', percentage);
      // Começar com width 0
      gsap.set(skillLevel, { width: 0 });
    }
  });
  
  // Detectar se estamos em mobile
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  
  // Em dispositivos móveis, aplicar animações mais simples e diretas
  if (isMobile) {
    console.log("Aplicando animações para dispositivos móveis");
    
    // Animar cards de skill diretamente sem ScrollTrigger
    gsap.fromTo(skillCards, 
      { opacity: 0.5, y: 15 },
      { 
        opacity: 1, 
        y: 0, 
        duration: 0.5, 
        stagger: 0.08,
        ease: 'power1.out',
        delay: 0.2
      }
    );
    
    // Animar as barras de progresso diretamente
    document.querySelectorAll('.skill-level').forEach(skillLevel => {
      const targetWidth = skillLevel.getAttribute('data-width');
      if (targetWidth) {
        gsap.fromTo(skillLevel,
          { width: "0%" },
          { 
            width: targetWidth,
            duration: 1,
            ease: "power1.out",
            delay: 0.5
          }
        );
      }
    });
    
    // Animar GitHub stats cards sem usar ScrollTrigger em mobile
    if (githubStats.length > 0) {
      gsap.fromTo(githubStats,
        { opacity: 0, y: 15 },
        { 
          opacity: 1, 
          y: 0, 
          duration: 0.6, 
          stagger: 0.1,
          ease: 'power1.out',
          delay: 0.5
        }
      );
    }
  } else {
    // Para desktop, usar as animações baseadas em ScrollTrigger
    gsap.from(skillCards, {
      scrollTrigger: {
        trigger: '#skills',
        start: 'top center+=100',
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      stagger: 0.1,
      ease: 'power2.out'
    });
    
    // Animar as barras de progresso quando entrarem na tela
    skillCards.forEach(card => {
      const skillLevel = card.querySelector('.skill-level');
      if (!skillLevel) return; // Segurança adicional
      
      // Obter largura do atributo data-percentage
      const targetWidth = skillLevel.getAttribute('data-percentage');
      
      // Começar com width zero
      gsap.set(skillLevel, { width: 0 });
      
      ScrollTrigger.create({
        trigger: card,
        start: 'top bottom-=100',
        once: true,
        onEnter: () => {
          gsap.to(skillLevel, {
            width: targetWidth,
            duration: 1.5,
            ease: 'power2.out'
          });
        }
      });
    });
    
    // Animação para os GitHub stats cards
    if (githubStats.length > 0) {
      gsap.from(githubStats, {
        scrollTrigger: {
          trigger: '.github-stats-container',
          start: 'top bottom-=50',
        },
        opacity: 0,
        y: 40,
        duration: 0.8,
        stagger: 0.2,
        ease: 'power2.out'
      });
    }
  }
}

// Adicionar o setup de animações de skills na função principal de animações
function setupAnimations() {
  // Verificar se a seção de skills existe
  const skillsSection = document.getElementById('skills');
  if (skillsSection) {
    console.log("Inicializando animações para a seção skills");
    
    // Configurar as animações de skills
    setupSkillsAnimations();
  }
  
  // Animações para a seção Sobre
  const sobreSection = document.querySelector('#sobre');
  if (sobreSection) {
    gsap.from('#sobre', {
      scrollTrigger: {
        trigger: '#sobre',
        start: 'top center+=100',
        toggleActions: 'play none none reverse'
      },
      opacity: 0,
      y: 50,
      duration: 0.8,
      ease: 'power2.out'
    });

    gsap.from('#sobre .about-text p', {
      scrollTrigger: {
        trigger: '#sobre',
        start: 'top center+=100',
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      stagger: 0.2,
      ease: 'power2.out'
    });

    gsap.from('#sobre .about-photo', {
      scrollTrigger: {
        trigger: '#sobre',
        start: 'top center+=100',
      },
      opacity: 0,
      x: 50,
      duration: 0.8,
      ease: 'power2.out'
    });
  }

  // Home - animações imediatas na carga da página
  gsap.from('.hire-tag', {
    y: 20,
    opacity: 0,
    duration: 0.6,
    ease: 'power2.out'
  });
  
  gsap.from('.hero-title', {
    y: 30,
    opacity: 0,
    duration: 0.8,
    delay: 0.2,
    ease: 'power2.out'
  });
  
  gsap.from('.hero-roles', {
    y: 20,
    opacity: 0,
    duration: 0.6,
    delay: 0.4,
    ease: 'power2.out'
  });
  
  gsap.from('.hero-description', {
    y: 20,
    opacity: 0,
    duration: 0.6,
    delay: 0.6,
    ease: 'power2.out'
  });
  
  // Ícones do hero: sem animação JS para liberar hover instantâneo
  gsap.set('.hero-social a', { clearProps: 'all' });
  
  gsap.from('.hero-circle', {
    scale: 0.8,
    opacity: 0,
    duration: 0.8,
    delay: 0.3,
    ease: 'power2.out'
  });
  
  gsap.from('.tech-stack-card', {
    x: window.innerWidth <= 768 ? 0 : -30,
    opacity: 0,
    duration: 0.6,
    delay: 0.5,
    ease: 'power2.out'
  });
  
  gsap.from('.terminal-card', {
    x: window.innerWidth <= 768 ? 0 : 30,
    opacity: 0,
    duration: 0.6,
    delay: 0.7,
    ease: 'power2.out'
  });
  
  const heroImg = document.querySelector('.hero img');
  const heroTitle = document.querySelector('.hero h1');
  const heroText = document.querySelector('.hero p');
  
  // Configurar animações iniciais para as barras de skills caso a página carregue diretamente nessa seção
  if (window.location.hash === '#skills') {
    setTimeout(() => {
      document.querySelectorAll('.skill-card .skill-level').forEach(skillLevel => {
        const originalWidth = skillLevel.getAttribute('data-width') || skillLevel.style.width;
        if (originalWidth) {
          gsap.fromTo(skillLevel, 
            { width: 0 }, 
            { width: originalWidth, duration: 1.5, ease: 'power2.out' }
          );
        }
      });
    }, 300);
  }
  
  // Projetos - animação baseada em scroll
  const projectCards = document.querySelectorAll('.project-card');
  if (projectCards.length > 0) {
    ScrollTrigger.batch(projectCards, {
      onEnter: batch => gsap.to(batch, {
        opacity: 1,
        y: 0,
        stagger: 0.15,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: true
      }),
      start: 'top bottom-=100',
      once: true
    });
  }
  
  // Experiência - animação baseada em scroll
  const experiencePhotos = document.querySelectorAll('.experience-photo');
  if (experiencePhotos.length > 0) {
    ScrollTrigger.batch(experiencePhotos, {
      onEnter: batch => gsap.to(batch, {
        opacity: 1,
        x: 0,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: true
      }),
      start: 'top bottom-=100',
      once: true
    });
  }
  
  const experienceItems = document.querySelectorAll('.experience-item');
  if (experienceItems.length > 0) {
    ScrollTrigger.batch(experienceItems, {
      onEnter: batch => gsap.to(batch, {
        opacity: 1,
        x: 0,
        stagger: 0.15,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: true
      }),
      start: 'top bottom-=100',
      once: true
    });
  }
  
  // Contato - animação baseada em scroll
  const contactInfo = document.querySelectorAll('.contact-info');
  if (contactInfo.length > 0) {
    ScrollTrigger.batch(contactInfo, {
      onEnter: batch => gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: true
      }),
      start: 'top bottom-=100',
      once: true
    });
  }
}

// Função para verificar se um elemento está visível na janela
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Inicialização
window.addEventListener('load', () => {
  // Determinar a seção inicial
  const initialSection = window.location.hash ? window.location.hash.substring(1) : sections[0].id;
  
  // Ativa o link de navegação correspondente
  navLinks.forEach(link => {
    link.classList.remove('active');
    if (link.getAttribute('href') === `#${initialSection}`) {
      link.classList.add('active');
    }
  });
  
  // Atualiza a navegação inicialmente
  updateNavigation();
  
  // Garantir que as barras de skills sejam animadas corretamente
  if (initialSection === 'skills' || isInViewport(document.getElementById('skills'))) {
    const skillLevels = document.querySelectorAll('.skill-level');
    skillLevels.forEach(skillLevel => {
      const percentage = skillLevel.getAttribute('data-percentage');
      if (percentage) {
        // Aplicar a animação da barra para o valor correto
        gsap.fromTo(skillLevel,
          { width: 0 },
          { width: percentage, duration: 1, ease: 'power2.out' }
        );
      }
    });
  }
});

// Corrigir comportamento dos links das redes sociais
const socialLinks = document.querySelectorAll('.header-social a');
socialLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault(); // Garante que o comportamento padrão seja evitado
    const url = link.getAttribute('href');
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer'); // Abre o link em uma nova aba
    }
  });
});

// Adicionar no início do arquivo, após as importações existentes
function setupThemeToggle() {
    const themeToggle = document.getElementById('theme-toggle');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    
    // Verifica o tema salvo ou usa a preferência do sistema
    const savedTheme = localStorage.getItem('theme');
    const currentTheme = savedTheme || (prefersDarkScheme.matches ? 'dark' : 'light');
    
    // Aplica o tema inicial
    document.documentElement.setAttribute('data-theme', currentTheme);
    updateThemeIcon(currentTheme);
    updateGitHubStats(currentTheme); // Adicionar esta linha
    themeToggle.title = t('theme.toggle');
    
    themeToggle.addEventListener('click', () => {
        const currentTheme = document.documentElement.getAttribute('data-theme');
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
        updateThemeIcon(newTheme);
          ensureHeroSocialInteractive();
    });
}

function updateThemeIcon(theme) {
    const themeToggle = document.getElementById('theme-toggle');
    const icon = themeToggle.querySelector('i');
    
    if (theme === 'dark') {
        icon.className = 'fas fa-moon';
        updateGitHubStats('dark');
    } else {
        icon.className = 'fas fa-sun';
        updateGitHubStats('light');
    }
}

  // Garante que ícones sociais do hero fiquem clicáveis/hover após qualquer alteração de tema/layout
  function ensureHeroSocialInteractive() {
    document.querySelectorAll('.hero-social a').forEach(el => {
      el.style.pointerEvents = 'auto';
      el.style.removeProperty('opacity');
      el.style.removeProperty('transform');
    });
  }

function updateGitHubStats(theme) {
    const isDark = theme === 'dark';
    const username = 'yurivfernandes1';
    
    // Cores para cada tema
    const colors = isDark ? {
        bg: '0D1117',
        text: '00cfd5',
        icon: '00cfd5',
        theme: 'react'
    } : {
        bg: 'ffffff',
        text: '0097a7',
        icon: '0097a7',
        theme: 'transparent'  // Mudado de 'default' para 'transparent'
    };
    
    // Atualizar as URLs das imagens
    const statsCard = document.querySelector('.github-stats-card:nth-child(1) img');
    const streakCard = document.querySelector('.github-stats-card:nth-child(2) img');
    const langsCard = document.querySelector('.github-stats-card:nth-child(3) img');
    
    if (statsCard) {
        statsCard.src = `https://github-readme-stats.vercel.app/api?username=${username}&show_icons=true&theme=${colors.theme}&hide_border=true&include_all_commits=true&count_private=true&text_color=${colors.text}&icon_color=${colors.icon}&bg_color=${colors.bg}&title_color=${colors.text}`;
    }
    
    if (streakCard) {
        streakCard.src = `https://github-readme-streak-stats.herokuapp.com/?user=${username}&theme=${isDark ? 'react' : 'default'}&hide_border=true&background=${colors.bg}&stroke=${colors.text}&ring=${colors.text}&fire=${colors.text}&currStreakNum=${colors.text}&sideNums=${colors.text}&currStreakLabel=${colors.text}&sideLabels=${colors.text}&dates=888888`;
    }
    
    if (langsCard) {
        langsCard.src = `https://github-readme-stats.vercel.app/api/top-langs/?username=${username}&layout=compact&theme=${colors.theme}&hide_border=true&text_color=${colors.text}&icon_color=${colors.icon}&bg_color=${colors.bg}&title_color=${colors.text}`;
    }
}

// Adicionar a chamada da função no evento DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    setupThemeToggle();
});